import React from 'react';

/**
 * Badge component - Displays the official Bail Enforcement Agent badge
 * Use this instead of Shield icon throughout the app
 */
const Badge = ({ className = "w-8 h-8", alt = "Bail Enforcement Agent Badge" }) => {
  return (
    <img 
      src="/images/badge-transparent.png" 
      alt={alt}
      className={`${className} object-contain`}
    />
  );
};

export default Badge;
